import {
  Companion_instance3fplhgf4ipvld as Companion_instance,
  Unit_instance104q5opgivhr8 as Unit_instance,
  _Result___init__impl__xyqfz81wclroc5pw7j2 as _Result___init__impl__xyqfz8,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  toString30pk9tzaqopn as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  createFailure8paxfkfa5dc7 as createFailure,
  Result3t1vadv16kmzk as Result,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  toString1h6jjoch8cjt8 as toString_0,
  newThrowablezl37abp36p5f as newThrowable,
  stackTraceToString2670q6lbhdojj as stackTraceToString,
  VOID7hggqo3abtya as VOID,
  isInterface3d6p8outrmvmk as isInterface,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  toLongw1zpgk99d84b as toLong,
  numberToLong1a4cndvg6c52s as numberToLong,
  intercepted2ogpsikxxj4u0 as intercepted,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  returnIfSuspended31u0py81m9mma as returnIfSuspended,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Long2qws0ah9gnpki as Long,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalStateException_init_$Init$urq27zgixtql as IllegalStateException_init_$Init$,
  captureStack1fzi4aczwc4hg as captureStack,
  replace3le3ie7l9k8aq as replace,
  closeFinally1sadm0w9gt3u4 as closeFinally,
  toString1pkumu07cwy4m as toString_1,
  IllegalStateException_init_$Create$3ib9qa3pip8n4 as IllegalStateException_init_$Create$,
  EmptyCoroutineContext_getInstance2bxophqwsfm9n as EmptyCoroutineContext_getInstance,
  Continuation1aa2oekvx7jm7 as Continuation,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  CancellationException_init_$Create$35hy9ztjr481d as CancellationException_init_$Create$,
  CancellationException3b36o9qz53rgr as CancellationException,
  ArrayList_init_$Create$2qnngtk1et9r9 as ArrayList_init_$Create$,
  listOf1jh22dvmctj1r as listOf,
  StringBuilder_init_$Create$23o1ixl6cos5l as StringBuilder_init_$Create$,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  encodeToByteArray22651fhg4p67t as encodeToByteArray,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  _Char___init__impl__6a9atx281r2pd9o601g as _Char___init__impl__6a9atx,
  replaceqbix900hl8kl as replace_0,
  IllegalArgumentException_init_$Create$310sysrobvll9 as IllegalArgumentException_init_$Create$,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  toByte4i43936u611k as toByte,
  decodeToString1x4faah2liw2p as decodeToString,
  setOf45ia9pnfhe90 as setOf,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  Char__toInt_impl_vasixd2xlaiz5u3itpv as Char__toInt_impl_vasixd,
} from './kotlin-kotlin-stdlib.mjs';
import {
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  launch1c91vkjzdi9sd as launch,
  startCoroutineCancellable18shtfwdieib as startCoroutineCancellable,
  get_job2zvlvce9o9a29 as get_job,
  Job13y4jkazwjho0 as Job,
  cancel1xim2hrvjmwpn as cancel,
  CopyableThrowable1mvc99jcyvivf as CopyableThrowable,
} from './kotlinx-coroutines-core.mjs';
import {
  Buffergs925ekssbch as Buffer,
  IOException_init_$Create$13y6ig657l2av as IOException_init_$Create$,
  EOFException_init_$Create$1fcl7h9im3v9r as EOFException_init_$Create$,
  readStringo8i62qxt5m4m as readString,
  readByteString2hnsbql6t4ads as readByteString,
  readString2nvggcfaijfhd as readString_0,
  IOException1wyutdmfe71nu as IOException,
  IOException_init_$Init$2zqugtfkvfigo as IOException_init_$Init$,
  IOException_init_$Create$39p2wsfj1vt0k as IOException_init_$Create$_0,
  readByteArray1fhzfwi2j014k as readByteArray,
  readString3v6duspiz33tv as readString_1,
  writeString33ca4btrgctw7 as writeString,
  IOException_init_$Init$2jjz3fe04l3kq as IOException_init_$Init$_0,
  readByteArray1ri21h2rciakw as readByteArray_0,
} from './kotlinx-io-kotlinx-io-core.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from './kotlinx-atomicfu.mjs';
import { decodeToString2ede220pr5xir as decodeToString_0 } from './kotlinx-io-kotlinx-io-bytestring.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForCompanion(Companion);
initMetadataForObject(Empty, 'Empty');
initMetadataForClass(Closed, 'Closed');
function resume() {
  return this.m3b().y8(Companion_getInstance().j3b_1);
}
function resume_0(throwable) {
  var tmp = this.m3b();
  var tmp_0;
  if (throwable == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(throwable));
    tmp_0 = new Result(tmp$ret$2);
  }
  var tmp1_elvis_lhs = tmp_0;
  return tmp.y8(tmp1_elvis_lhs == null ? Companion_getInstance().j3b_1 : tmp1_elvis_lhs.ul_1);
}
initMetadataForInterface(Task, 'Task');
initMetadataForClass(Read, 'Read', VOID, VOID, [Task]);
initMetadataForClass(Write, 'Write', VOID, VOID, [Task]);
initMetadataForCoroutine($awaitContentCOROUTINE$0, CoroutineImpl);
initMetadataForCoroutine($flushCOROUTINE$1, CoroutineImpl);
initMetadataForCoroutine($flushAndCloseCOROUTINE$2, CoroutineImpl);
function awaitContent$default(min, $completion, $super) {
  min = min === VOID ? 1 : min;
  return $super === VOID ? this.y3d(min, $completion) : $super.y3d.call(this, min, $completion);
}
initMetadataForInterface(ByteReadChannel_1, 'ByteReadChannel', VOID, VOID, VOID, [1]);
initMetadataForClass(ByteChannel, 'ByteChannel', ByteChannel, VOID, [ByteReadChannel_1], [1, 0]);
initMetadataForClass(ConcurrentIOException, 'ConcurrentIOException', VOID, IllegalStateException);
initMetadataForClass(ByteReadChannel$Companion$Empty$1, VOID, VOID, VOID, [ByteReadChannel_1], [1]);
initMetadataForCompanion(Companion_0);
initMetadataForCoroutine($readRemainingCOROUTINE$3, CoroutineImpl);
initMetadataForCoroutine($readPacketCOROUTINE$4, CoroutineImpl);
initMetadataForCoroutine($discardCOROUTINE$5, CoroutineImpl);
initMetadataForCoroutine($readAvailableCOROUTINE$7, CoroutineImpl);
initMetadataForCoroutine($toByteArrayCOROUTINE$9, CoroutineImpl);
initMetadataForCoroutine($copyToCOROUTINE$10, CoroutineImpl);
initMetadataForCoroutine($readBufferCOROUTINE$12, CoroutineImpl);
initMetadataForCoroutine($readUTF8LineToCOROUTINE$13, CoroutineImpl);
initMetadataForCoroutine($skipIfFoundCOROUTINE$15, CoroutineImpl);
initMetadataForCoroutine($readUntilCOROUTINE$16, CoroutineImpl);
initMetadataForCoroutine($peekCOROUTINE$17, CoroutineImpl);
initMetadataForCoroutine($readByteCOROUTINE$18, CoroutineImpl);
initMetadataForCoroutine($readUntil$appendPartialMatchCOROUTINE$19, CoroutineImpl);
initMetadataForCoroutine($flushIfNeededCOROUTINE$20, CoroutineImpl);
initMetadataForClass(WriterJob, 'WriterJob');
initMetadataForClass(WriterScope, 'WriterScope', VOID, VOID, [CoroutineScope]);
initMetadataForClass(NO_CALLBACK$1, VOID, VOID, VOID, [Continuation]);
initMetadataForFunctionReference(ByteWriteChannel$flushAndClose$ref, VOID, VOID, [0]);
initMetadataForLambda(writer$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($writePacketCOROUTINE$21, CoroutineImpl);
initMetadataForClass(CloseToken, 'CloseToken');
initMetadataForCoroutine($awaitContentCOROUTINE$22, CoroutineImpl);
initMetadataForClass(CountedByteReadChannel, 'CountedByteReadChannel', VOID, VOID, [ByteReadChannel_1], [1]);
initMetadataForClass(ClosedByteChannelException, 'ClosedByteChannelException', ClosedByteChannelException, IOException);
initMetadataForClass(ClosedReadChannelException, 'ClosedReadChannelException', ClosedReadChannelException, ClosedByteChannelException);
initMetadataForClass(ClosedWriteChannelException, 'ClosedWriteChannelException', ClosedWriteChannelException, ClosedByteChannelException);
initMetadataForCompanion(Companion_1);
initMetadataForClass(LineEndingMode, 'LineEndingMode');
initMetadataForClass(SourceByteReadChannel, 'SourceByteReadChannel', VOID, VOID, [ByteReadChannel_1], [1]);
initMetadataForClass(MalformedInputException, 'MalformedInputException', VOID, IOException);
initMetadataForClass(TooLongLineException, 'TooLongLineException', VOID, MalformedInputException);
function close() {
  this.x1h();
}
initMetadataForInterface(ObjectPool, 'ObjectPool', VOID, VOID, [AutoCloseable]);
initMetadataForClass(DefaultPool, 'DefaultPool', VOID, VOID, [ObjectPool]);
initMetadataForClass(ByteArrayPool$1, VOID, VOID, DefaultPool);
initMetadataForClass(NoPoolImpl, 'NoPoolImpl', VOID, VOID, [ObjectPool]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(Charset, 'Charset');
initMetadataForObject(Charsets, 'Charsets');
initMetadataForClass(CharsetDecoder, 'CharsetDecoder');
initMetadataForClass(CharsetEncoder, 'CharsetEncoder');
initMetadataForClass(CharsetImpl, 'CharsetImpl', VOID, Charset);
initMetadataForClass(CharsetEncoderImpl, 'CharsetEncoderImpl', VOID, CharsetEncoder);
initMetadataForClass(CharsetDecoderImpl, 'CharsetDecoderImpl', VOID, CharsetDecoder);
initMetadataForClass(toKtor$1);
initMetadataForClass(TextDecoderFallback, 'TextDecoderFallback');
//endregion
function Companion() {
  Companion_instance_0 = this;
  this.i3b_1 = new Closed(null);
  var tmp = this;
  // Inline function 'kotlin.Companion.success' call
  tmp.j3b_1 = _Result___init__impl__xyqfz8(Unit_instance);
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 == null)
    new Companion();
  return Companion_instance_0;
}
function Empty() {
}
protoOf(Empty).toString = function () {
  return 'Empty';
};
protoOf(Empty).hashCode = function () {
  return -231472095;
};
protoOf(Empty).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Empty))
    return false;
  other instanceof Empty || THROW_CCE();
  return true;
};
var Empty_instance;
function Empty_getInstance() {
  return Empty_instance;
}
function Closed(cause) {
  this.k3b_1 = cause;
}
protoOf(Closed).toString = function () {
  return 'Closed(cause=' + toString(this.k3b_1) + ')';
};
protoOf(Closed).hashCode = function () {
  return this.k3b_1 == null ? 0 : hashCode(this.k3b_1);
};
protoOf(Closed).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Closed))
    return false;
  var tmp0_other_with_cast = other instanceof Closed ? other : THROW_CCE();
  if (!equals(this.k3b_1, tmp0_other_with_cast.k3b_1))
    return false;
  return true;
};
function Task() {
}
function Read(continuation) {
  this.q3b_1 = continuation;
  this.r3b_1 = null;
  if (get_DEVELOPMENT_MODE()) {
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = newThrowable('ReadTask 0x' + toString_0(hashCode(this.q3b_1), 16));
    stackTraceToString(this_0);
    tmp.r3b_1 = this_0;
  }
}
protoOf(Read).m3b = function () {
  return this.q3b_1;
};
protoOf(Read).l3b = function () {
  return this.r3b_1;
};
protoOf(Read).n3b = function () {
  return 'read';
};
function Write(continuation) {
  this.s3b_1 = continuation;
  this.t3b_1 = null;
  if (get_DEVELOPMENT_MODE()) {
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = newThrowable('WriteTask 0x' + toString_0(hashCode(this.s3b_1), 16));
    stackTraceToString(this_0);
    tmp.t3b_1 = this_0;
  }
}
protoOf(Write).m3b = function () {
  return this.s3b_1;
};
protoOf(Write).l3b = function () {
  return this.t3b_1;
};
protoOf(Write).n3b = function () {
  return 'write';
};
function moveFlushToReadBuffer($this) {
  // Inline function 'io.ktor.utils.io.locks.synchronized' call
  $this.x3b_1;
  $this.v3b_1.n39($this.z3b_1);
  $this.w3b_1 = 0;
  // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
  var current = $this.y3b_1.kotlinx$atomicfu$value;
  var tmp;
  if (current instanceof Write) {
    tmp = $this.y3b_1.atomicfu$compareAndSet(current, Empty_instance);
  } else {
    tmp = false;
  }
  if (tmp) {
    current.o3b();
  }
}
function closeSlot($this, cause) {
  var closeContinuation = !(cause == null) ? new Closed(cause) : Companion_getInstance().i3b_1;
  var continuation = $this.y3b_1.atomicfu$getAndSet(closeContinuation);
  if (isInterface(continuation, Task)) {
    continuation.p3b(cause);
  }
}
function ClosedReadChannelException$_init_$ref_ix0089() {
  var l = function (p0) {
    return new ClosedReadChannelException(p0);
  };
  l.callableName = '<init>';
  return l;
}
function ClosedWriteChannelException$_init_$ref_ef15ty() {
  var l = function (p0) {
    return new ClosedWriteChannelException(p0);
  };
  l.callableName = '<init>';
  return l;
}
function $awaitContentCOROUTINE$0(_this__u8e3s4, min, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.k3c_1 = _this__u8e3s4;
  this.l3c_1 = min;
}
protoOf($awaitContentCOROUTINE$0).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          rethrowCloseCauseIfNeeded_1(this.k3c_1);
          if (this.k3c_1.z3b_1.m().b1(toLong(this.l3c_1)) >= 0)
            return true;
          var tmp_0 = this;
          tmp_0.m3c_1 = this.k3c_1;
          this.n3c_1 = this.m3c_1;
          this.n8_1 = 1;
          continue $sm;
        case 1:
          if (!(numberToLong(this.k3c_1.w3b_1).r2(this.k3c_1.z3b_1.m()).b1(toLong(this.l3c_1)) < 0 && this.k3c_1.b3c_1.kotlinx$atomicfu$value == null)) {
            this.n8_1 = 3;
            continue $sm;
          }

          this.n8_1 = 2;
          var cancellable = new CancellableContinuationImpl(intercepted(this), 1);
          cancellable.z1i();
          var tmp0 = this.n3c_1;
          var tmp1 = new Read(cancellable);
          l$ret$1: do {
            var previous = tmp0.y3b_1.kotlinx$atomicfu$value;
            if (!(previous instanceof Closed)) {
              if (!tmp0.y3b_1.atomicfu$compareAndSet(previous, tmp1)) {
                tmp1.o3b();
                break l$ret$1;
              }
            }
            if (previous instanceof Read) {
              previous.p3b(new ConcurrentIOException(tmp1.n3b(), previous.l3b()));
            } else {
              if (isInterface(previous, Task)) {
                previous.o3b();
              } else {
                if (previous instanceof Closed) {
                  tmp1.p3b(previous.k3b_1);
                  break l$ret$1;
                } else {
                  if (!equals(previous, Empty_instance)) {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
            if (!(numberToLong(this.k3c_1.w3b_1).r2(this.k3c_1.z3b_1.m()).b1(toLong(this.l3c_1)) < 0 && this.k3c_1.b3c_1.kotlinx$atomicfu$value == null)) {
              var current = tmp0.y3b_1.kotlinx$atomicfu$value;
              var tmp_1;
              if (current instanceof Read) {
                tmp_1 = tmp0.y3b_1.atomicfu$compareAndSet(current, Empty_instance);
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                current.o3b();
              }
            }
          }
           while (false);
          suspendResult = returnIfSuspended(cancellable.h1j(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.n8_1 = 1;
          continue $sm;
        case 3:
          if (this.k3c_1.z3b_1.m().b1(new Long(1048576, 0)) < 0) {
            moveFlushToReadBuffer(this.k3c_1);
          }

          return this.k3c_1.z3b_1.m().b1(toLong(this.l3c_1)) >= 0;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $flushCOROUTINE$1(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.w3c_1 = _this__u8e3s4;
}
protoOf($flushCOROUTINE$1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          rethrowCloseCauseIfNeeded_1(this.w3c_1);
          this.w3c_1.z3c();
          if (this.w3c_1.w3b_1 < 1048576)
            return Unit_instance;
          var tmp_0 = this;
          tmp_0.x3c_1 = this.w3c_1;
          this.y3c_1 = this.x3c_1;
          this.n8_1 = 1;
          continue $sm;
        case 1:
          if (!(this.w3c_1.w3b_1 >= 1048576 && this.w3c_1.b3c_1.kotlinx$atomicfu$value == null)) {
            this.n8_1 = 3;
            continue $sm;
          }

          this.n8_1 = 2;
          var cancellable = new CancellableContinuationImpl(intercepted(this), 1);
          cancellable.z1i();
          var tmp0 = this.y3c_1;
          var tmp1 = new Write(cancellable);
          l$ret$1: do {
            var previous = tmp0.y3b_1.kotlinx$atomicfu$value;
            if (!(previous instanceof Closed)) {
              if (!tmp0.y3b_1.atomicfu$compareAndSet(previous, tmp1)) {
                tmp1.o3b();
                break l$ret$1;
              }
            }
            if (previous instanceof Write) {
              previous.p3b(new ConcurrentIOException(tmp1.n3b(), previous.l3b()));
            } else {
              if (isInterface(previous, Task)) {
                previous.o3b();
              } else {
                if (previous instanceof Closed) {
                  tmp1.p3b(previous.k3b_1);
                  break l$ret$1;
                } else {
                  if (!equals(previous, Empty_instance)) {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
            if (!(this.w3c_1.w3b_1 >= 1048576 && this.w3c_1.b3c_1.kotlinx$atomicfu$value == null)) {
              var current = tmp0.y3b_1.kotlinx$atomicfu$value;
              var tmp_1;
              if (current instanceof Write) {
                tmp_1 = tmp0.y3b_1.atomicfu$compareAndSet(current, Empty_instance);
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                current.o3b();
              }
            }
          }
           while (false);
          suspendResult = returnIfSuspended(cancellable.h1j(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.n8_1 = 1;
          continue $sm;
        case 3:
          return Unit_instance;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $flushAndCloseCOROUTINE$2(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.i3d_1 = _this__u8e3s4;
}
protoOf($flushAndCloseCOROUTINE$2).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          var tmp_0 = this;
          tmp_0.j3d_1 = this.i3d_1;
          this.k3d_1 = this.j3d_1;
          this.o8_1 = 2;
          var tmp_1 = this;
          tmp_1.m3d_1 = Companion_instance;
          var tmp_2 = this;
          tmp_2.n3d_1 = this.k3d_1;
          this.o3d_1 = this.n3d_1;
          this.n8_1 = 1;
          suspendResult = this.o3d_1.p3d(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var tmp_3 = this;
          this.m3d_1;
          tmp_3.l3d_1 = _Result___init__impl__xyqfz8(Unit_instance);
          this.o8_1 = 4;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 4;
          var tmp_4 = this.q8_1;
          if (tmp_4 instanceof Error) {
            var e = this.q8_1;
            var tmp_5 = this;
            tmp_5.l3d_1 = _Result___init__impl__xyqfz8(createFailure(e));
            this.n8_1 = 3;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 3:
          this.o8_1 = 4;
          if (!this.i3d_1.b3c_1.atomicfu$compareAndSet(null, get_CLOSED()))
            return Unit_instance;
          closeSlot(this.i3d_1, null);
          return Unit_instance;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 4) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
function ByteChannel(autoFlush) {
  autoFlush = autoFlush === VOID ? false : autoFlush;
  this.u3b_1 = autoFlush;
  this.v3b_1 = new Buffer();
  this.w3b_1 = 0;
  this.x3b_1 = new Object();
  this.y3b_1 = atomic$ref$1(Empty_instance);
  this.z3b_1 = new Buffer();
  this.a3c_1 = new Buffer();
  this.b3c_1 = atomic$ref$1(null);
}
protoOf(ByteChannel).q3d = function () {
  var tmp0_safe_receiver = this.b3c_1.kotlinx$atomicfu$value;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.s3d(ClosedReadChannelException$_init_$ref_ix0089());
  }
  if (this.z3b_1.k38()) {
    moveFlushToReadBuffer(this);
  }
  return this.z3b_1;
};
protoOf(ByteChannel).t3d = function () {
  if (this.u3d()) {
    var tmp0_safe_receiver = this.b3c_1.kotlinx$atomicfu$value;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp0_safe_receiver.s3d(ClosedWriteChannelException$_init_$ref_ef15ty());
    }
    if (tmp == null)
      throw new ClosedWriteChannelException();
  }
  return this.a3c_1;
};
protoOf(ByteChannel).v3d = function () {
  var tmp0_safe_receiver = this.b3c_1.kotlinx$atomicfu$value;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w3d();
};
protoOf(ByteChannel).u3d = function () {
  return !(this.b3c_1.kotlinx$atomicfu$value == null);
};
protoOf(ByteChannel).x3d = function () {
  return !(this.v3d() == null) || (this.u3d() && this.w3b_1 === 0 && this.z3b_1.k38());
};
protoOf(ByteChannel).y3d = function (min, $completion) {
  var tmp = new $awaitContentCOROUTINE$0(this, min, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(ByteChannel).p3d = function ($completion) {
  var tmp = new $flushCOROUTINE$1(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(ByteChannel).z3c = function () {
  if (this.a3c_1.k38())
    return Unit_instance;
  // Inline function 'io.ktor.utils.io.locks.synchronized' call
  this.x3b_1;
  var count = this.a3c_1.m().d1();
  this.v3b_1.c3a(this.a3c_1);
  this.w3b_1 = this.w3b_1 + count | 0;
  // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
  var current = this.y3b_1.kotlinx$atomicfu$value;
  var tmp;
  if (current instanceof Read) {
    tmp = this.y3b_1.atomicfu$compareAndSet(current, Empty_instance);
  } else {
    tmp = false;
  }
  if (tmp) {
    current.o3b();
  }
};
protoOf(ByteChannel).a4 = function () {
  this.z3c();
  if (!this.b3c_1.atomicfu$compareAndSet(null, get_CLOSED()))
    return Unit_instance;
  closeSlot(this, null);
};
protoOf(ByteChannel).a3e = function ($completion) {
  var tmp = new $flushAndCloseCOROUTINE$2(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(ByteChannel).b3e = function (cause) {
  if (!(this.b3c_1.kotlinx$atomicfu$value == null))
    return Unit_instance;
  var closedToken = new CloseToken(cause);
  this.b3c_1.atomicfu$compareAndSet(null, closedToken);
  var wrappedCause = closedToken.w3d();
  closeSlot(this, wrappedCause);
};
protoOf(ByteChannel).toString = function () {
  return 'ByteChannel[' + hashCode(this) + ']';
};
function ConcurrentIOException(taskName, cause) {
  cause = cause === VOID ? null : cause;
  IllegalStateException_init_$Init$('Concurrent ' + taskName + ' attempts', cause, this);
  captureStack(this, ConcurrentIOException);
}
function ByteReadChannel(content, offset, length) {
  offset = offset === VOID ? 0 : offset;
  length = length === VOID ? content.length : length;
  // Inline function 'kotlin.also' call
  var this_0 = new Buffer();
  this_0.t39(content, offset, offset + length | 0);
  var source = this_0;
  return ByteReadChannel_0(source);
}
function ByteReadChannel_0(source) {
  return new SourceByteReadChannel(source);
}
function ByteReadChannel$Companion$Empty$1() {
  this.c3e_1 = null;
  this.d3e_1 = new Buffer();
}
protoOf(ByteReadChannel$Companion$Empty$1).v3d = function () {
  return this.c3e_1;
};
protoOf(ByteReadChannel$Companion$Empty$1).x3d = function () {
  return true;
};
protoOf(ByteReadChannel$Companion$Empty$1).q3d = function () {
  return this.d3e_1;
};
protoOf(ByteReadChannel$Companion$Empty$1).y3d = function (min, $completion) {
  return false;
};
protoOf(ByteReadChannel$Companion$Empty$1).b3e = function (cause) {
};
function Companion_0() {
  Companion_instance_1 = this;
  var tmp = this;
  tmp.e3e_1 = new ByteReadChannel$Companion$Empty$1();
}
var Companion_instance_1;
function Companion_getInstance_0() {
  if (Companion_instance_1 == null)
    new Companion_0();
  return Companion_instance_1;
}
function ByteReadChannel_1() {
}
function cancel_0(_this__u8e3s4) {
  _this__u8e3s4.b3e(IOException_init_$Create$('Channel was cancelled'));
}
function readRemaining(_this__u8e3s4, $completion) {
  var tmp = new $readRemainingCOROUTINE$3(_this__u8e3s4, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function get_availableForRead(_this__u8e3s4) {
  return _this__u8e3s4.q3d().j38().m().d1();
}
function readPacket(_this__u8e3s4, packet, $completion) {
  var tmp = new $readPacketCOROUTINE$4(_this__u8e3s4, packet, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function discard(_this__u8e3s4, max, $completion) {
  max = max === VOID ? new Long(-1, 2147483647) : max;
  var tmp = new $discardCOROUTINE$5(_this__u8e3s4, max, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function readAvailable(_this__u8e3s4, buffer, offset, length, $completion) {
  offset = offset === VOID ? 0 : offset;
  length = length === VOID ? buffer.length - offset | 0 : length;
  var tmp = new $readAvailableCOROUTINE$7(_this__u8e3s4, buffer, offset, length, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function toByteArray(_this__u8e3s4, $completion) {
  var tmp = new $toByteArrayCOROUTINE$9(_this__u8e3s4, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function copyTo(_this__u8e3s4, channel, limit, $completion) {
  var tmp = new $copyToCOROUTINE$10(_this__u8e3s4, channel, limit, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function rethrowCloseCauseIfNeeded(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.v3d();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
}
function readBuffer(_this__u8e3s4, $completion) {
  var tmp = new $readBufferCOROUTINE$12(_this__u8e3s4, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function readUTF8LineTo(_this__u8e3s4, out, max, lineEnding, $completion) {
  max = max === VOID ? 2147483647 : max;
  lineEnding = lineEnding === VOID ? Companion_getInstance_1().j3h_1 : lineEnding;
  var tmp = new $readUTF8LineToCOROUTINE$13(_this__u8e3s4, out, max, lineEnding, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function rethrowCloseCauseIfNeeded_0(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.v3d();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
}
function rethrowCloseCauseIfNeeded_1(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.v3d();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
}
function skipIfFound(_this__u8e3s4, byteString, $completion) {
  var tmp = new $skipIfFoundCOROUTINE$15(_this__u8e3s4, byteString, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function readUntil(_this__u8e3s4, matchString, writeChannel, limit, ignoreMissing, $completion) {
  limit = limit === VOID ? new Long(-1, 2147483647) : limit;
  ignoreMissing = ignoreMissing === VOID ? false : ignoreMissing;
  var tmp = new $readUntilCOROUTINE$16(_this__u8e3s4, matchString, writeChannel, limit, ignoreMissing, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function peek(_this__u8e3s4, count, $completion) {
  var tmp = new $peekCOROUTINE$17(_this__u8e3s4, count, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function buildPartialMatchTable(byteString) {
  var table = new Int32Array(byteString.m());
  var j = 0;
  var inductionVariable = 1;
  var last = byteString.m();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      while (j > 0 && !(byteString.o(i) === byteString.o(j))) {
        j = table[j - 1 | 0];
      }
      if (byteString.o(i) === byteString.o(j)) {
        j = j + 1 | 0;
      }
      table[i] = j;
    }
     while (inductionVariable < last);
  return table;
}
function readByte(_this__u8e3s4, $completion) {
  var tmp = new $readByteCOROUTINE$18(_this__u8e3s4, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function toSingleLineString(_this__u8e3s4) {
  return replace(decodeToString_0(_this__u8e3s4), '\n', '\\n');
}
function readUTF8LineTo$checkLineEndingAllowed($lineEnding, lineEndingToCheck) {
  if (!LineEndingMode__contains_impl_q5pr68($lineEnding, lineEndingToCheck)) {
    throw IOException_init_$Create$('Unexpected line ending ' + LineEndingMode__toString_impl_j4h76r(lineEndingToCheck) + ', while expected ' + LineEndingMode__toString_impl_j4h76r($lineEnding));
  }
}
function readUntil$appendPartialMatch($writeChannel, matchBuffer, matchIndex, rc, $completion) {
  var tmp = new $readUntil$appendPartialMatchCOROUTINE$19($writeChannel, matchBuffer, matchIndex, rc, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function readUntil$resetPartialMatch(matchIndex, $matchString, partialMatchTable, byte) {
  while (matchIndex._v > 0 && !(byte === $matchString.o(matchIndex._v))) {
    matchIndex._v = partialMatchTable[matchIndex._v - 1 | 0];
  }
}
function $readRemainingCOROUTINE$3(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.n3e_1 = _this__u8e3s4;
}
protoOf($readRemainingCOROUTINE$3).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.o3e_1 = BytePacketBuilder();
          this.n8_1 = 1;
          continue $sm;
        case 1:
          if (!!this.n3e_1.x3d()) {
            this.n8_1 = 3;
            continue $sm;
          }

          this.o3e_1.c3a(this.n3e_1.q3d());
          this.n8_1 = 2;
          suspendResult = this.n3e_1.z3d(VOID, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.n8_1 = 1;
          continue $sm;
        case 3:
          rethrowCloseCauseIfNeeded(this.n3e_1);
          return this.o3e_1.j38();
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $readPacketCOROUTINE$4(_this__u8e3s4, packet, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.x3e_1 = _this__u8e3s4;
  this.y3e_1 = packet;
}
protoOf($readPacketCOROUTINE$4).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 6;
          this.z3e_1 = new Buffer();
          this.n8_1 = 1;
          continue $sm;
        case 1:
          if (!(this.z3e_1.m().b1(toLong(this.y3e_1)) < 0)) {
            this.n8_1 = 5;
            continue $sm;
          }

          if (this.x3e_1.q3d().k38()) {
            this.n8_1 = 2;
            suspendResult = this.x3e_1.z3d(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 3;
            continue $sm;
          }

        case 2:
          this.n8_1 = 3;
          continue $sm;
        case 3:
          if (this.x3e_1.x3d()) {
            this.n8_1 = 5;
            continue $sm;
          } else {
            this.n8_1 = 4;
            continue $sm;
          }

        case 4:
          if (get_remaining(this.x3e_1.q3d()).b1(numberToLong(this.y3e_1).s2(this.z3e_1.m())) > 0) {
            this.x3e_1.q3d().m39(this.z3e_1, numberToLong(this.y3e_1).s2(this.z3e_1.m()));
          } else {
            this.x3e_1.q3d().n39(this.z3e_1);
          }

          this.n8_1 = 1;
          continue $sm;
        case 5:
          if (this.z3e_1.m().b1(toLong(this.y3e_1)) < 0) {
            throw EOFException_init_$Create$('Not enough data available, required ' + this.y3e_1 + ' bytes but only ' + this.z3e_1.m().toString() + ' available');
          }

          return this.z3e_1;
        case 6:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 6) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $discardCOROUTINE$5(_this__u8e3s4, max, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.i3f_1 = _this__u8e3s4;
  this.j3f_1 = max;
}
protoOf($discardCOROUTINE$5).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 5;
          this.k3f_1 = this.j3f_1;
          this.n8_1 = 1;
          continue $sm;
        case 1:
          if (!(this.k3f_1.b1(new Long(0, 0)) > 0 && !this.i3f_1.x3d())) {
            this.n8_1 = 4;
            continue $sm;
          }

          if (get_availableForRead(this.i3f_1) === 0) {
            this.n8_1 = 2;
            suspendResult = this.i3f_1.z3d(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 3;
            continue $sm;
          }

        case 2:
          this.n8_1 = 3;
          continue $sm;
        case 3:
          var tmp0 = this.k3f_1;
          var b = get_remaining(this.i3f_1.q3d());
          var count = tmp0.b1(b) <= 0 ? tmp0 : b;
          discard_0(this.i3f_1.q3d(), count);
          this.k3f_1 = this.k3f_1.s2(count);
          this.n8_1 = 1;
          continue $sm;
        case 4:
          return this.j3f_1.s2(this.k3f_1);
        case 5:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 5) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $readAvailableCOROUTINE$7(_this__u8e3s4, buffer, offset, length, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.t3f_1 = _this__u8e3s4;
  this.u3f_1 = buffer;
  this.v3f_1 = offset;
  this.w3f_1 = length;
}
protoOf($readAvailableCOROUTINE$7).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          if (this.t3f_1.x3d())
            return -1;
          if (this.t3f_1.q3d().k38()) {
            this.n8_1 = 1;
            suspendResult = this.t3f_1.z3d(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 2;
            continue $sm;
          }

        case 1:
          this.n8_1 = 2;
          continue $sm;
        case 2:
          if (this.t3f_1.x3d())
            return -1;
          return readAvailable_0(this.t3f_1.q3d(), this.u3f_1, this.v3f_1, this.w3f_1);
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $toByteArrayCOROUTINE$9(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.f3g_1 = _this__u8e3s4;
}
protoOf($toByteArrayCOROUTINE$9).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = readBuffer(this.f3g_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var ARGUMENT = suspendResult;
          return readBytes(ARGUMENT);
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $copyToCOROUTINE$10(_this__u8e3s4, channel, limit, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.o3g_1 = _this__u8e3s4;
  this.p3g_1 = channel;
  this.q3g_1 = limit;
}
protoOf($copyToCOROUTINE$10).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 12;
          this.r3g_1 = this.q3g_1;
          this.n8_1 = 1;
          continue $sm;
        case 1:
          this.o8_1 = 8;
          this.o8_1 = 7;
          this.n8_1 = 2;
          continue $sm;
        case 2:
          if (!(!this.o3g_1.x3d() && this.r3g_1.b1(new Long(0, 0)) > 0)) {
            this.n8_1 = 6;
            continue $sm;
          }

          if (this.o3g_1.q3d().k38()) {
            this.n8_1 = 3;
            suspendResult = this.o3g_1.z3d(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 4;
            continue $sm;
          }

        case 3:
          this.n8_1 = 4;
          continue $sm;
        case 4:
          var tmp_0 = this;
          var tmp0 = this.r3g_1;
          var b = get_remaining(this.o3g_1.q3d());
          tmp_0.t3g_1 = tmp0.b1(b) <= 0 ? tmp0 : b;
          this.o3g_1.q3d().m39(this.p3g_1.t3d(), this.t3g_1);
          this.r3g_1 = this.r3g_1.s2(this.t3g_1);
          this.n8_1 = 5;
          suspendResult = this.p3g_1.p3d(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 5:
          this.n8_1 = 2;
          continue $sm;
        case 6:
          this.s3g_1 = Unit_instance;
          this.o8_1 = 12;
          this.n8_1 = 10;
          continue $sm;
        case 7:
          this.o8_1 = 8;
          var tmp_1 = this.q8_1;
          if (tmp_1 instanceof Error) {
            this.u3g_1 = this.q8_1;
            var tmp_2 = this;
            this.o3g_1.b3e(this.u3g_1);
            close_0(this.p3g_1, this.u3g_1);
            throw this.u3g_1;
          } else {
            throw this.q8_1;
          }

        case 8:
          this.o8_1 = 12;
          this.v3g_1 = this.q8_1;
          this.n8_1 = 9;
          suspendResult = this.p3g_1.p3d(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 9:
          throw this.v3g_1;
        case 10:
          this.o8_1 = 12;
          this.n8_1 = 11;
          suspendResult = this.p3g_1.p3d(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 11:
          return this.q3g_1.s2(this.r3g_1);
        case 12:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 12) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $readBufferCOROUTINE$12(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.e3h_1 = _this__u8e3s4;
}
protoOf($readBufferCOROUTINE$12).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.f3h_1 = new Buffer();
          this.n8_1 = 1;
          continue $sm;
        case 1:
          if (!!this.e3h_1.x3d()) {
            this.n8_1 = 3;
            continue $sm;
          }

          this.f3h_1.c3a(this.e3h_1.q3d());
          this.n8_1 = 2;
          suspendResult = this.e3h_1.z3d(VOID, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.n8_1 = 1;
          continue $sm;
        case 3:
          var tmp0_safe_receiver = this.e3h_1.v3d();
          if (tmp0_safe_receiver == null)
            null;
          else {
            throw tmp0_safe_receiver;
          }

          return this.f3h_1;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $readUTF8LineToCOROUTINE$13(_this__u8e3s4, out, max, lineEnding, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.t3h_1 = _this__u8e3s4;
  this.u3h_1 = out;
  this.v3h_1 = max;
  this.w3h_1 = lineEnding;
}
protoOf($readUTF8LineToCOROUTINE$13).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 21;
          if (this.t3h_1.q3d().k38()) {
            this.n8_1 = 1;
            suspendResult = this.t3h_1.z3d(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 2;
            continue $sm;
          }

        case 1:
          this.n8_1 = 2;
          continue $sm;
        case 2:
          if (this.t3h_1.x3d())
            return false;
          var tmp_0 = this;
          tmp_0.x3h_1 = new Buffer();
          this.n8_1 = 3;
          continue $sm;
        case 3:
          this.z3h_1 = this.x3h_1;
          this.a3i_1 = null;
          this.n8_1 = 4;
          continue $sm;
        case 4:
          this.n8_1 = 5;
          continue $sm;
        case 5:
          this.n8_1 = 6;
          continue $sm;
        case 6:
          this.o8_1 = 18;
          this.o8_1 = 17;
          var tmp_1 = this;
          tmp_1.c3i_1 = this.z3h_1;
          this.d3i_1 = this.c3i_1;
          this.n8_1 = 7;
          continue $sm;
        case 7:
          if (!!this.t3h_1.x3d()) {
            this.n8_1 = 14;
            continue $sm;
          }

          this.n8_1 = 8;
          continue $sm;
        case 8:
          if (!!this.t3h_1.q3d().k38()) {
            this.n8_1 = 12;
            continue $sm;
          }

          this.e3i_1 = this.t3h_1.q3d().n38();
          if (this.e3i_1 === 13) {
            if (this.t3h_1.q3d().k38()) {
              this.n8_1 = 10;
              suspendResult = this.t3h_1.z3d(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n8_1 = 11;
              continue $sm;
            }
          } else {
            if (this.e3i_1 === 10) {
              readUTF8LineTo$checkLineEndingAllowed(this.w3h_1, Companion_getInstance_1().h3h_1);
              this.u3h_1.f(readString(this.d3i_1));
              this.b3i_1 = true;
              this.o8_1 = 21;
              this.n8_1 = 15;
              continue $sm;
            } else {
              this.d3i_1.d3a(this.e3i_1);
              this.n8_1 = 9;
              continue $sm;
            }
          }

        case 9:
          this.n8_1 = 8;
          continue $sm;
        case 10:
          this.n8_1 = 11;
          continue $sm;
        case 11:
          if (this.t3h_1.q3d().j38().f39(new Long(0, 0)) === 10) {
            readUTF8LineTo$checkLineEndingAllowed(this.w3h_1, Companion_getInstance_1().i3h_1);
            discard_0(this.t3h_1.q3d(), new Long(1, 0));
          } else {
            readUTF8LineTo$checkLineEndingAllowed(this.w3h_1, Companion_getInstance_1().g3h_1);
          }

          this.u3h_1.f(readString(this.d3i_1));
          this.b3i_1 = true;
          this.o8_1 = 21;
          this.n8_1 = 15;
          continue $sm;
        case 12:
          if (this.d3i_1.m().b1(toLong(this.v3h_1)) >= 0) {
            throw new TooLongLineException('Line exceeds limit of ' + this.v3h_1 + ' characters');
          }

          this.n8_1 = 13;
          suspendResult = this.t3h_1.z3d(VOID, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 13:
          this.n8_1 = 7;
          continue $sm;
        case 14:
          var tmp_2 = this;
          var this_0 = this.d3i_1.m().b1(new Long(0, 0)) > 0;
          if (this_0) {
            this.u3h_1.f(readString(this.d3i_1));
          }

          tmp_2.b3i_1 = this_0;
          this.o8_1 = 21;
          this.n8_1 = 15;
          var tmp_3 = this;
          continue $sm;
        case 15:
          var tmp_4 = this.b3i_1;
          this.o8_1 = 21;
          closeFinally(this.z3h_1, this.a3i_1);
          return tmp_4;
        case 16:
          this.o8_1 = 21;
          var tmp_5 = this;
          closeFinally(this.z3h_1, this.a3i_1);
          tmp_5.y3h_1 = Unit_instance;
          this.n8_1 = 20;
          continue $sm;
        case 17:
          this.o8_1 = 18;
          var tmp_6 = this.q8_1;
          if (tmp_6 instanceof Error) {
            var e = this.q8_1;
            var tmp_7 = this;
            this.a3i_1 = e;
            throw e;
          } else {
            throw this.q8_1;
          }

        case 18:
          this.o8_1 = 21;
          var t = this.q8_1;
          closeFinally(this.z3h_1, this.a3i_1);
          throw t;
        case 19:
          this.o8_1 = 21;
          closeFinally(this.z3h_1, this.a3i_1);
          if (false) {
            this.n8_1 = 3;
            continue $sm;
          }

          this.n8_1 = 20;
          continue $sm;
        case 20:
          return Unit_instance;
        case 21:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 21) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
function $skipIfFoundCOROUTINE$15(_this__u8e3s4, byteString, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.n3i_1 = _this__u8e3s4;
  this.o3i_1 = byteString;
}
protoOf($skipIfFoundCOROUTINE$15).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.n8_1 = 1;
          suspendResult = peek(this.n3i_1, this.o3i_1.m(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.p3i_1 = suspendResult;
          if (equals(this.p3i_1, this.o3i_1)) {
            this.n8_1 = 3;
            suspendResult = discard(this.n3i_1, toLong(this.o3i_1.m()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 2;
            continue $sm;
          }

        case 2:
          return false;
        case 3:
          return true;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $readUntilCOROUTINE$16(_this__u8e3s4, matchString, writeChannel, limit, ignoreMissing, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.y3i_1 = _this__u8e3s4;
  this.z3i_1 = matchString;
  this.a3j_1 = writeChannel;
  this.b3j_1 = limit;
  this.c3j_1 = ignoreMissing;
}
protoOf($readUntilCOROUTINE$16).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 11;
          if (!(this.z3i_1.m() > 0)) {
            var message = 'Empty match string not permitted for readUntil';
            throw IllegalStateException_init_$Create$(toString_1(message));
          }

          this.d3j_1 = buildPartialMatchTable(this.z3i_1);
          this.e3j_1 = {_v: 0};
          this.f3j_1 = new Int8Array(this.z3i_1.m());
          this.g3j_1 = {_v: new Long(0, 0)};
          this.n8_1 = 1;
          continue $sm;
        case 1:
          if (!!this.y3i_1.x3d()) {
            this.n8_1 = 7;
            continue $sm;
          }

          this.n8_1 = 2;
          suspendResult = readByte(this.y3i_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.h3j_1 = suspendResult;
          if (this.e3j_1._v > 0 && !(this.h3j_1 === this.z3i_1.o(this.e3j_1._v))) {
            this.n8_1 = 3;
            suspendResult = readUntil$appendPartialMatch(this.a3j_1, this.f3j_1, this.e3j_1, this.g3j_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 4;
            continue $sm;
          }

        case 3:
          readUntil$resetPartialMatch(this.e3j_1, this.z3i_1, this.d3j_1, this.h3j_1);
          this.n8_1 = 4;
          continue $sm;
        case 4:
          if (this.h3j_1 === this.z3i_1.o(this.e3j_1._v)) {
            var tmp_0 = this;
            this.f3j_1[this.e3j_1._v] = this.h3j_1;
            this.e3j_1._v = this.e3j_1._v + 1 | 0;
            if (this.e3j_1._v === this.z3i_1.m()) {
              return this.g3j_1._v;
            }
            tmp_0.i3j_1 = Unit_instance;
            this.n8_1 = 6;
            continue $sm;
          } else {
            this.n8_1 = 5;
            suspendResult = writeByte(this.a3j_1, this.h3j_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          }

        case 5:
          var tmp_1 = this;
          var _unary__edvuaz = this.g3j_1._v;
          this.g3j_1._v = _unary__edvuaz.w2();
          tmp_1.i3j_1 = _unary__edvuaz;
          this.n8_1 = 6;
          continue $sm;
        case 6:
          if (this.g3j_1._v.b1(this.b3j_1) > 0) {
            throw IOException_init_$Create$('Limit of ' + this.b3j_1.toString() + ' bytes exceeded while scanning for "' + decodeToString_0(this.z3i_1) + '"');
          }

          this.n8_1 = 1;
          continue $sm;
        case 7:
          if (this.c3j_1) {
            this.n8_1 = 9;
            suspendResult = readUntil$appendPartialMatch(this.a3j_1, this.f3j_1, this.e3j_1, this.g3j_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 8;
            continue $sm;
          }

        case 8:
          throw IOException_init_$Create$('Expected "' + toSingleLineString(this.z3i_1) + '" but encountered end of input');
        case 9:
          this.n8_1 = 10;
          suspendResult = this.a3j_1.p3d(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 10:
          return this.g3j_1._v;
        case 11:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 11) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $peekCOROUTINE$17(_this__u8e3s4, count, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.r3j_1 = _this__u8e3s4;
  this.s3j_1 = count;
}
protoOf($peekCOROUTINE$17).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          if (this.r3j_1.x3d())
            return null;
          this.n8_1 = 1;
          suspendResult = this.r3j_1.y3d(this.s3j_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var ARGUMENT = suspendResult;
          if (!ARGUMENT) {
            return null;
          } else {
            this.n8_1 = 2;
            continue $sm;
          }

        case 2:
          return readByteString(this.r3j_1.q3d().o39(), this.s3j_1);
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $readByteCOROUTINE$18(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.b3k_1 = _this__u8e3s4;
}
protoOf($readByteCOROUTINE$18).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          if (this.b3k_1.q3d().k38()) {
            this.n8_1 = 1;
            suspendResult = this.b3k_1.z3d(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 2;
            continue $sm;
          }

        case 1:
          this.n8_1 = 2;
          continue $sm;
        case 2:
          if (this.b3k_1.q3d().k38()) {
            throw EOFException_init_$Create$('Not enough data available');
          }

          return this.b3k_1.q3d().n38();
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $readUntil$appendPartialMatchCOROUTINE$19($writeChannel, matchBuffer, matchIndex, rc, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.k3k_1 = $writeChannel;
  this.l3k_1 = matchBuffer;
  this.m3k_1 = matchIndex;
  this.n3k_1 = rc;
}
protoOf($readUntil$appendPartialMatchCOROUTINE$19).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = writeFully(this.k3k_1, this.l3k_1, 0, this.m3k_1._v, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var tmp0 = this.n3k_1._v;
          var other = this.m3k_1._v;
          this.n3k_1._v = tmp0.r2(toLong(other));
          this.m3k_1._v = 0;
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function flushIfNeeded(_this__u8e3s4, $completion) {
  var tmp = new $flushIfNeededCOROUTINE$20(_this__u8e3s4, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function $flushIfNeededCOROUTINE$20(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.w3k_1 = _this__u8e3s4;
}
protoOf($flushIfNeededCOROUTINE$20).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          rethrowCloseCauseIfNeeded_0(this.w3k_1);
          var tmp_0;
          var tmp_1 = this.w3k_1;
          var tmp0_safe_receiver = tmp_1 instanceof ByteChannel ? tmp_1 : null;
          if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u3b_1) === true) {
            tmp_0 = true;
          } else {
            tmp_0 = get_size(this.w3k_1.t3d()) >= 1048576;
          }

          if (tmp_0) {
            this.n8_1 = 1;
            suspendResult = this.w3k_1.p3d(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 2;
            continue $sm;
          }

        case 1:
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return Unit_instance;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function get_NO_CALLBACK() {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  return NO_CALLBACK;
}
var NO_CALLBACK;
function WriterJob(channel, job) {
  this.x3k_1 = channel;
  this.y3k_1 = job;
}
protoOf(WriterJob).j1k = function () {
  return this.y3k_1;
};
function writer(_this__u8e3s4, coroutineContext, autoFlush, block) {
  coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
  autoFlush = autoFlush === VOID ? false : autoFlush;
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  return writer_0(_this__u8e3s4, coroutineContext, new ByteChannel(), block);
}
function WriterScope(channel, coroutineContext) {
  this.z3k_1 = channel;
  this.a3l_1 = coroutineContext;
}
protoOf(WriterScope).h1e = function () {
  return this.a3l_1;
};
function writeFully(_this__u8e3s4, value, startIndex, endIndex, $completion) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  endIndex = endIndex === VOID ? value.length : endIndex;
  _this__u8e3s4.t3d().t39(value, startIndex, endIndex);
  return flushIfNeeded(_this__u8e3s4, $completion);
}
function writePacket(_this__u8e3s4, source, $completion) {
  var tmp = new $writePacketCOROUTINE$21(_this__u8e3s4, source, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function get_isCompleted(_this__u8e3s4) {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  return _this__u8e3s4.j1k().d1f();
}
function close_0(_this__u8e3s4, cause) {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  if (cause == null) {
    fireAndForget(ByteWriteChannel$flushAndClose$ref_0(_this__u8e3s4));
  } else {
    _this__u8e3s4.b3e(cause);
  }
}
function invokeOnCompletion(_this__u8e3s4, block) {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  var tmp = _this__u8e3s4.j1k();
  tmp.k1f(invokeOnCompletion$lambda(block));
}
function writer_0(_this__u8e3s4, coroutineContext, channel, block) {
  coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  // Inline function 'kotlin.apply' call
  var this_0 = launch(_this__u8e3s4, coroutineContext, VOID, writer$slambda_0(block, channel, null));
  this_0.k1f(writer$lambda(channel));
  var job = this_0;
  return new WriterJob(channel, job);
}
function fireAndForget(_this__u8e3s4) {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  startCoroutineCancellable(_this__u8e3s4, get_NO_CALLBACK());
}
function writeByte(_this__u8e3s4, value, $completion) {
  _this__u8e3s4.t3d().d3a(value);
  return flushIfNeeded(_this__u8e3s4, $completion);
}
function NO_CALLBACK$1() {
  this.l3l_1 = EmptyCoroutineContext_getInstance();
}
protoOf(NO_CALLBACK$1).t8 = function () {
  return this.l3l_1;
};
protoOf(NO_CALLBACK$1).u8 = function (result) {
  return Unit_instance;
};
protoOf(NO_CALLBACK$1).y8 = function (result) {
  return this.u8(result);
};
function ByteWriteChannel$flushAndClose$ref($boundThis) {
  this.m3l_1 = $boundThis;
}
protoOf(ByteWriteChannel$flushAndClose$ref).n3l = function ($completion) {
  return this.m3l_1.a3e($completion);
};
protoOf(ByteWriteChannel$flushAndClose$ref).ma = function ($completion) {
  return this.n3l($completion);
};
function ByteWriteChannel$flushAndClose$ref_0($boundThis) {
  var i = new ByteWriteChannel$flushAndClose$ref($boundThis);
  var l = function ($completion) {
    return i.n3l($completion);
  };
  l.callableName = 'flushAndClose';
  l.$arity = 0;
  return l;
}
function invokeOnCompletion$lambda($block) {
  return function (it) {
    $block();
    return Unit_instance;
  };
}
function writer$slambda($block, $channel, resultContinuation) {
  this.w3l_1 = $block;
  this.x3l_1 = $channel;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(writer$slambda).r3m = function ($this$launch, $completion) {
  var tmp = this.s3m($this$launch, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(writer$slambda).h9 = function (p1, $completion) {
  return this.r3m((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(writer$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 14;
          this.z3l_1 = Job(get_job(this.y3l_1.h1e()));
          this.n8_1 = 1;
          continue $sm;
        case 1:
          this.o8_1 = 4;
          this.o8_1 = 3;
          this.n8_1 = 2;
          suspendResult = this.w3l_1(new WriterScope(this.x3l_1, this.y3l_1.h1e().jg(this.z3l_1)), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.z3l_1.e1l();
          var tmp_0 = this;
          var tmp_1;
          if (get_job(this.y3l_1.h1e()).e1f()) {
            this.x3l_1.b3e(get_job(this.y3l_1.h1e()).h1f());
            tmp_1 = Unit_instance;
          }

          tmp_0.a3m_1 = tmp_1;
          this.o8_1 = 14;
          this.n8_1 = 9;
          continue $sm;
        case 3:
          this.o8_1 = 4;
          var tmp_2 = this.q8_1;
          if (tmp_2 instanceof Error) {
            this.b3m_1 = this.q8_1;
            var tmp_3 = this;
            cancel(this.z3l_1, 'Exception thrown while writing to channel', this.b3m_1);
            this.x3l_1.b3e(this.b3m_1);
            tmp_3.a3m_1 = Unit_instance;
            this.o8_1 = 14;
            this.n8_1 = 9;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 4:
          this.o8_1 = 14;
          this.c3m_1 = this.q8_1;
          this.n8_1 = 5;
          suspendResult = this.z3l_1.o1f(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 5:
          var tmp_4 = this;
          tmp_4.d3m_1 = this.y3l_1;
          this.e3m_1 = this.d3m_1;
          this.o8_1 = 7;
          var tmp_5 = this;
          tmp_5.g3m_1 = Companion_instance;
          var tmp_6 = this;
          tmp_6.h3m_1 = this.e3m_1;
          this.i3m_1 = this.h3m_1;
          this.n8_1 = 6;
          suspendResult = this.x3l_1.a3e(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 6:
          this.j3m_1 = Unit_instance;
          var tmp_7 = this;
          this.g3m_1;
          var value = this.j3m_1;
          tmp_7.f3m_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 14;
          this.n8_1 = 8;
          continue $sm;
        case 7:
          this.o8_1 = 14;
          var tmp_8 = this.q8_1;
          if (tmp_8 instanceof Error) {
            this.k3m_1 = this.q8_1;
            var tmp_9 = this;
            var exception = this.k3m_1;
            tmp_9.f3m_1 = _Result___init__impl__xyqfz8(createFailure(exception));
            this.n8_1 = 8;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 8:
          this.o8_1 = 14;
          throw this.c3m_1;
        case 9:
          this.o8_1 = 14;
          this.n8_1 = 10;
          suspendResult = this.z3l_1.o1f(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 10:
          var tmp_10 = this;
          tmp_10.l3m_1 = this.y3l_1;
          this.m3m_1 = this.l3m_1;
          this.o8_1 = 12;
          var tmp_11 = this;
          tmp_11.o3m_1 = Companion_instance;
          var tmp_12 = this;
          tmp_12.p3m_1 = this.m3m_1;
          this.q3m_1 = this.p3m_1;
          this.n8_1 = 11;
          suspendResult = this.x3l_1.a3e(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 11:
          var tmp_13 = this;
          this.o3m_1;
          tmp_13.n3m_1 = _Result___init__impl__xyqfz8(Unit_instance);
          this.o8_1 = 14;
          this.n8_1 = 13;
          continue $sm;
        case 12:
          this.o8_1 = 14;
          var tmp_14 = this.q8_1;
          if (tmp_14 instanceof Error) {
            var e = this.q8_1;
            var tmp_15 = this;
            tmp_15.n3m_1 = _Result___init__impl__xyqfz8(createFailure(e));
            this.n8_1 = 13;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 13:
          this.o8_1 = 14;
          return Unit_instance;
        case 14:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 14) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
protoOf(writer$slambda).s3m = function ($this$launch, completion) {
  var i = new writer$slambda(this.w3l_1, this.x3l_1, completion);
  i.y3l_1 = $this$launch;
  return i;
};
function writer$slambda_0($block, $channel, resultContinuation) {
  var i = new writer$slambda($block, $channel, resultContinuation);
  var l = function ($this$launch, $completion) {
    return i.r3m($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function writer$lambda($channel) {
  return function (it) {
    var tmp;
    if (!(it == null) && !$channel.u3d()) {
      $channel.b3e(it);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function $writePacketCOROUTINE$21(_this__u8e3s4, source, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.j3l_1 = _this__u8e3s4;
  this.k3l_1 = source;
}
protoOf($writePacketCOROUTINE$21).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.n8_1 = 1;
          continue $sm;
        case 1:
          if (!!this.k3l_1.k38()) {
            this.n8_1 = 3;
            continue $sm;
          }

          this.j3l_1.t3d().x39(this.k3l_1, get_remaining(this.k3l_1));
          this.n8_1 = 2;
          suspendResult = flushIfNeeded(this.j3l_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.n8_1 = 1;
          continue $sm;
        case 3:
          return Unit_instance;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
var properties_initialized_ByteWriteChannelOperations_kt_acrf6u;
function _init_properties_ByteWriteChannelOperations_kt__i7slrs() {
  if (!properties_initialized_ByteWriteChannelOperations_kt_acrf6u) {
    properties_initialized_ByteWriteChannelOperations_kt_acrf6u = true;
    NO_CALLBACK = new NO_CALLBACK$1();
  }
}
function get_CLOSED() {
  _init_properties_CloseToken_kt__9ucr41();
  return CLOSED;
}
var CLOSED;
function ClosedByteChannelException$_init_$ref_yjp351() {
  var l = function (p0) {
    return new ClosedByteChannelException(p0);
  };
  l.callableName = '<init>';
  return l;
}
function CloseToken(origin) {
  this.r3d_1 = origin;
}
protoOf(CloseToken).t3m = function (wrap) {
  var tmp0_subject = this.r3d_1;
  var tmp;
  if (tmp0_subject == null) {
    tmp = null;
  } else {
    if (!(tmp0_subject == null) ? isInterface(tmp0_subject, CopyableThrowable) : false) {
      tmp = this.r3d_1.n1l();
    } else {
      if (tmp0_subject instanceof CancellationException) {
        tmp = CancellationException_init_$Create$(this.r3d_1.message, this.r3d_1);
      } else {
        tmp = wrap(this.r3d_1);
      }
    }
  }
  return tmp;
};
protoOf(CloseToken).w3d = function (wrap, $super) {
  var tmp;
  if (wrap === VOID) {
    tmp = ClosedByteChannelException$_init_$ref_yjp351();
  } else {
    tmp = wrap;
  }
  wrap = tmp;
  return $super === VOID ? this.t3m(wrap) : $super.t3m.call(this, wrap);
};
protoOf(CloseToken).s3d = function (wrap) {
  var tmp0_safe_receiver = this.t3m(wrap);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
  return tmp;
};
var properties_initialized_CloseToken_kt_lgg8zn;
function _init_properties_CloseToken_kt__9ucr41() {
  if (!properties_initialized_CloseToken_kt_lgg8zn) {
    properties_initialized_CloseToken_kt_lgg8zn = true;
    CLOSED = new CloseToken(null);
  }
}
function updateConsumed($this) {
  $this.x3m_1 = $this.x3m_1.r2($this.w3m_1.s2($this.v3m_1.m()));
  $this.w3m_1 = $this.v3m_1.m();
}
function $awaitContentCOROUTINE$22(_this__u8e3s4, min, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.g3n_1 = _this__u8e3s4;
  this.h3n_1 = min;
}
protoOf($awaitContentCOROUTINE$22).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          if (this.g3n_1.q3d().m().b1(toLong(this.h3n_1)) >= 0) {
            this.i3n_1 = true;
            this.n8_1 = 2;
            continue $sm;
          } else {
            this.n8_1 = 1;
            suspendResult = this.g3n_1.u3m_1.y3d(this.h3n_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          }

        case 1:
          this.i3n_1 = suspendResult;
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return this.i3n_1;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function CountedByteReadChannel(delegate) {
  this.u3m_1 = delegate;
  this.v3m_1 = new Buffer();
  this.w3m_1 = new Long(0, 0);
  this.x3m_1 = new Long(0, 0);
}
protoOf(CountedByteReadChannel).j3n = function () {
  updateConsumed(this);
  return this.x3m_1;
};
protoOf(CountedByteReadChannel).v3d = function () {
  return this.u3m_1.v3d();
};
protoOf(CountedByteReadChannel).x3d = function () {
  return this.v3m_1.k38() && this.u3m_1.x3d();
};
protoOf(CountedByteReadChannel).q3d = function () {
  updateConsumed(this);
  var appended = this.v3m_1.c3a(this.u3m_1.q3d());
  this.w3m_1 = this.w3m_1.r2(appended);
  return this.v3m_1;
};
protoOf(CountedByteReadChannel).y3d = function (min, $completion) {
  var tmp = new $awaitContentCOROUTINE$22(this, min, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(CountedByteReadChannel).b3e = function (cause) {
  this.u3m_1.b3e(cause);
  this.v3m_1.a4();
};
function counted(_this__u8e3s4) {
  return new CountedByteReadChannel(_this__u8e3s4);
}
function readText(_this__u8e3s4) {
  return readString_0(_this__u8e3s4);
}
function ClosedByteChannelException(cause) {
  cause = cause === VOID ? null : cause;
  IOException_init_$Init$(cause == null ? null : cause.message, cause, this);
  captureStack(this, ClosedByteChannelException);
}
function ClosedReadChannelException(cause) {
  cause = cause === VOID ? null : cause;
  ClosedByteChannelException.call(this, cause);
  captureStack(this, ClosedReadChannelException);
}
function ClosedWriteChannelException(cause) {
  cause = cause === VOID ? null : cause;
  ClosedByteChannelException.call(this, cause);
  captureStack(this, ClosedWriteChannelException);
}
function _LineEndingMode___init__impl__jo5bul(mode) {
  return mode;
}
function _get_mode__dah3bc($this) {
  return $this;
}
function LineEndingMode__contains_impl_q5pr68($this, other) {
  return (_get_mode__dah3bc($this) | _get_mode__dah3bc(other)) === _get_mode__dah3bc($this);
}
function LineEndingMode__plus_impl_ttpz2j($this, other) {
  return _LineEndingMode___init__impl__jo5bul(_get_mode__dah3bc($this) | _get_mode__dah3bc(other));
}
function LineEndingMode__toString_impl_j4h76r($this) {
  var tmp;
  if ($this === Companion_getInstance_1().g3h_1) {
    tmp = 'CR';
  } else if ($this === Companion_getInstance_1().h3h_1) {
    tmp = 'LF';
  } else if ($this === Companion_getInstance_1().i3h_1) {
    tmp = 'CRLF';
  } else {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = Companion_getInstance_1().k3h_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      var it = element.k3n_1;
      if (LineEndingMode__contains_impl_q5pr68($this, it)) {
        destination.e(element);
      }
    }
    tmp = toString_1(destination);
  }
  return tmp;
}
function Companion_1() {
  Companion_instance_2 = this;
  this.g3h_1 = _LineEndingMode___init__impl__jo5bul(1);
  this.h3h_1 = _LineEndingMode___init__impl__jo5bul(2);
  this.i3h_1 = _LineEndingMode___init__impl__jo5bul(4);
  this.j3h_1 = _LineEndingMode___init__impl__jo5bul(7);
  this.k3h_1 = listOf([new LineEndingMode(this.g3h_1), new LineEndingMode(this.h3h_1), new LineEndingMode(this.i3h_1)]);
}
var Companion_instance_2;
function Companion_getInstance_1() {
  if (Companion_instance_2 == null)
    new Companion_1();
  return Companion_instance_2;
}
function LineEndingMode__hashCode_impl_2mopm4($this) {
  return $this;
}
function LineEndingMode__equals_impl_qyr4nk($this, other) {
  if (!(other instanceof LineEndingMode))
    return false;
  if (!($this === (other instanceof LineEndingMode ? other.k3n_1 : THROW_CCE())))
    return false;
  return true;
}
function LineEndingMode(mode) {
  Companion_getInstance_1();
  this.k3n_1 = mode;
}
protoOf(LineEndingMode).toString = function () {
  return LineEndingMode__toString_impl_j4h76r(this.k3n_1);
};
protoOf(LineEndingMode).hashCode = function () {
  return LineEndingMode__hashCode_impl_2mopm4(this.k3n_1);
};
protoOf(LineEndingMode).equals = function (other) {
  return LineEndingMode__equals_impl_qyr4nk(this.k3n_1, other);
};
function SourceByteReadChannel(source) {
  this.l3n_1 = source;
  this.m3n_1 = null;
}
protoOf(SourceByteReadChannel).v3d = function () {
  var tmp0_safe_receiver = this.m3n_1;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w3d();
};
protoOf(SourceByteReadChannel).x3d = function () {
  return this.l3n_1.k38();
};
protoOf(SourceByteReadChannel).q3d = function () {
  var tmp0_safe_receiver = this.v3d();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
  return this.l3n_1.j38();
};
protoOf(SourceByteReadChannel).y3d = function (min, $completion) {
  var tmp0_safe_receiver = this.v3d();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
  return this.l3n_1.m38(toLong(min));
};
protoOf(SourceByteReadChannel).b3e = function (cause) {
  if (!(this.m3n_1 == null))
    return Unit_instance;
  this.l3n_1.a4();
  var tmp = this;
  var tmp1_elvis_lhs = cause == null ? null : cause.message;
  tmp.m3n_1 = new CloseToken(IOException_init_$Create$_0(tmp1_elvis_lhs == null ? 'Channel was cancelled' : tmp1_elvis_lhs, cause));
};
function decode(_this__u8e3s4, input, max) {
  max = max === VOID ? 2147483647 : max;
  var tmp0 = toLong(max);
  // Inline function 'kotlin.comparisons.minOf' call
  var b = input.j38().m();
  // Inline function 'kotlin.text.buildString' call
  var capacity = (tmp0.b1(b) <= 0 ? tmp0 : b).d1();
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$(capacity);
  decode_0(_this__u8e3s4, input, this_0, max);
  return this_0.toString();
}
function encodeToImpl(_this__u8e3s4, destination, input, fromIndex, toIndex) {
  var start = fromIndex;
  if (start >= toIndex)
    return Unit_instance;
  $l$loop: while (true) {
    var rc = encodeImpl(_this__u8e3s4, input, start, toIndex, destination);
    // Inline function 'kotlin.check' call
    if (!(rc >= 0)) {
      throw IllegalStateException_init_$Create$('Check failed.');
    }
    start = start + rc | 0;
    if (start >= toIndex)
      break $l$loop;
  }
}
function TooLongLineException(message) {
  MalformedInputException.call(this, message);
  captureStack(this, TooLongLineException);
}
function encode(_this__u8e3s4, input, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
  // Inline function 'io.ktor.utils.io.core.buildPacket' call
  var builder = new Buffer();
  encodeToImpl(_this__u8e3s4, builder, input, fromIndex, toIndex);
  return builder;
}
function canRead(_this__u8e3s4) {
  return !_this__u8e3s4.k38();
}
function readBytes(_this__u8e3s4, count) {
  count = count === VOID ? _this__u8e3s4.m().d1() : count;
  return readByteArray(_this__u8e3s4, count);
}
function BytePacketBuilder() {
  return new Buffer();
}
function writePacket_0(_this__u8e3s4, packet) {
  _this__u8e3s4.c3a(packet);
}
function build(_this__u8e3s4) {
  return _this__u8e3s4.j38();
}
function writeFully_0(_this__u8e3s4, buffer, offset, length) {
  offset = offset === VOID ? 0 : offset;
  length = length === VOID ? buffer.length - offset | 0 : length;
  _this__u8e3s4.t39(buffer, offset, offset + length | 0);
}
function get_size(_this__u8e3s4) {
  return _this__u8e3s4.j38().m().d1();
}
var ByteReadPacketEmpty;
function get_remaining(_this__u8e3s4) {
  _init_properties_ByteReadPacket_kt__28475y();
  return _this__u8e3s4.j38().m();
}
function discard_0(_this__u8e3s4, count) {
  count = count === VOID ? new Long(-1, 2147483647) : count;
  _init_properties_ByteReadPacket_kt__28475y();
  _this__u8e3s4.m38(count);
  // Inline function 'kotlin.comparisons.minOf' call
  var b = get_remaining(_this__u8e3s4);
  var countToDiscard = count.b1(b) <= 0 ? count : b;
  _this__u8e3s4.j38().h39(countToDiscard);
  return countToDiscard;
}
function takeWhile(_this__u8e3s4, block) {
  _init_properties_ByteReadPacket_kt__28475y();
  while (!_this__u8e3s4.k38() && block(_this__u8e3s4.j38())) {
  }
}
var properties_initialized_ByteReadPacket_kt_hw4st4;
function _init_properties_ByteReadPacket_kt__28475y() {
  if (!properties_initialized_ByteReadPacket_kt_hw4st4) {
    properties_initialized_ByteReadPacket_kt_hw4st4 = true;
    ByteReadPacketEmpty = new Buffer();
  }
}
function readAvailable_0(_this__u8e3s4, buffer, offset, length) {
  offset = offset === VOID ? 0 : offset;
  length = length === VOID ? buffer.length - offset | 0 : length;
  var result = _this__u8e3s4.i39(buffer, offset, offset + length | 0);
  return result === -1 ? 0 : result;
}
function toByteArray_0(_this__u8e3s4, charset) {
  charset = charset === VOID ? Charsets_getInstance().n3n_1 : charset;
  if (charset.equals(Charsets_getInstance().n3n_1))
    return encodeToByteArray(_this__u8e3s4, VOID, VOID, true);
  return encodeToByteArray_0(charset.q3n(), _this__u8e3s4, 0, _this__u8e3s4.length);
}
function readText_0(_this__u8e3s4, charset, max) {
  charset = charset === VOID ? Charsets_getInstance().n3n_1 : charset;
  max = max === VOID ? 2147483647 : max;
  if (charset.equals(Charsets_getInstance().n3n_1)) {
    if (max === 2147483647)
      return readString_0(_this__u8e3s4);
    var tmp0 = _this__u8e3s4.j38().m();
    // Inline function 'kotlin.math.min' call
    var b = toLong(max);
    var count = tmp0.b1(b) <= 0 ? tmp0 : b;
    return readString_1(_this__u8e3s4, count);
  }
  return decode(charset.r3n(), _this__u8e3s4, max);
}
function writeText(_this__u8e3s4, text, fromIndex, toIndex, charset) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? charSequenceLength(text) : toIndex;
  charset = charset === VOID ? Charsets_getInstance().n3n_1 : charset;
  if (charset === Charsets_getInstance().n3n_1) {
    return writeString(_this__u8e3s4, toString_1(text), fromIndex, toIndex);
  }
  encodeToImpl(charset.q3n(), _this__u8e3s4, text, fromIndex, toIndex);
}
function get_ByteArrayPool() {
  _init_properties_ByteArrayPool_kt__kfi3uj();
  return ByteArrayPool;
}
var ByteArrayPool;
function ByteArrayPool$1() {
  DefaultPool.call(this, 128);
}
protoOf(ByteArrayPool$1).v3n = function () {
  return new Int8Array(4096);
};
var properties_initialized_ByteArrayPool_kt_td6pfh;
function _init_properties_ByteArrayPool_kt__kfi3uj() {
  if (!properties_initialized_ByteArrayPool_kt_td6pfh) {
    properties_initialized_ByteArrayPool_kt_td6pfh = true;
    ByteArrayPool = new ByteArrayPool$1();
  }
}
function ObjectPool() {
}
function NoPoolImpl() {
}
protoOf(NoPoolImpl).d3o = function (instance) {
  return Unit_instance;
};
protoOf(NoPoolImpl).x1h = function () {
  return Unit_instance;
};
function Companion_2() {
}
protoOf(Companion_2).e3o = function (name) {
  switch (name) {
    case 'UTF-8':
    case 'utf-8':
    case 'UTF8':
    case 'utf8':
      return Charsets_getInstance().n3n_1;
  }
  var tmp;
  var tmp_0;
  switch (name) {
    case 'ISO-8859-1':
    case 'iso-8859-1':
      tmp_0 = true;
      break;
    default:
      // Inline function 'kotlin.let' call

      var it = replace_0(name, _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45));
      var tmp_1;
      if (it === 'iso-8859-1') {
        tmp_1 = true;
      } else {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_1 = it.toLowerCase() === 'iso-8859-1';
      }

      tmp_0 = tmp_1;
      break;
  }
  if (tmp_0) {
    tmp = true;
  } else {
    tmp = name === 'latin1' || name === 'Latin1';
  }
  if (tmp) {
    return Charsets_getInstance().o3n_1;
  }
  throw IllegalArgumentException_init_$Create$('Charset ' + name + ' is not supported');
};
protoOf(Companion_2).f3o = function (charset) {
  var tmp;
  switch (charset) {
    case 'UTF-8':
    case 'utf-8':
    case 'UTF8':
    case 'utf8':
      tmp = true;
      break;
    default:
      var tmp_0;
      var tmp_1;
      switch (charset) {
        case 'ISO-8859-1':
        case 'iso-8859-1':
          tmp_1 = true;
          break;
        default:
          // Inline function 'kotlin.let' call

          var it = replace_0(charset, _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45));
          var tmp_2;
          if (it === 'iso-8859-1') {
            tmp_2 = true;
          } else {
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_2 = it.toLowerCase() === 'iso-8859-1';
          }

          tmp_1 = tmp_2;
          break;
      }

      if (tmp_1) {
        tmp_0 = true;
      } else {
        tmp_0 = charset === 'latin1';
      }

      if (tmp_0) {
        tmp = true;
      } else {
        tmp = false;
      }

      break;
  }
  return tmp;
};
var Companion_instance_3;
function Companion_getInstance_2() {
  return Companion_instance_3;
}
function Charset(_name) {
  this.p3n_1 = _name;
}
protoOf(Charset).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !(this.constructor == other.constructor))
    return false;
  if (!(other instanceof Charset))
    THROW_CCE();
  return this.p3n_1 === other.p3n_1;
};
protoOf(Charset).hashCode = function () {
  return getStringHashCode(this.p3n_1);
};
protoOf(Charset).toString = function () {
  return this.p3n_1;
};
function get_name(_this__u8e3s4) {
  return _this__u8e3s4.p3n_1;
}
function Charsets() {
  Charsets_instance = this;
  this.n3n_1 = new CharsetImpl('UTF-8');
  this.o3n_1 = new CharsetImpl('ISO-8859-1');
}
var Charsets_instance;
function Charsets_getInstance() {
  if (Charsets_instance == null)
    new Charsets();
  return Charsets_instance;
}
function MalformedInputException(message) {
  IOException_init_$Init$_0(message, this);
  captureStack(this, MalformedInputException);
}
function CharsetDecoder(_charset) {
  this.g3o_1 = _charset;
}
function encodeToByteArray_0(_this__u8e3s4, input, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
  return encodeToByteArrayImpl(_this__u8e3s4, input, fromIndex, toIndex);
}
function CharsetEncoder(_charset) {
  this.h3o_1 = _charset;
}
function CharsetImpl(name) {
  Charset.call(this, name);
}
protoOf(CharsetImpl).q3n = function () {
  return new CharsetEncoderImpl(this);
};
protoOf(CharsetImpl).r3n = function () {
  return new CharsetDecoderImpl(this);
};
function encodeToByteArrayImpl(_this__u8e3s4, input, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
  var start = fromIndex;
  if (start >= toIndex)
    return new Int8Array(0);
  var dst = new Buffer();
  var rc = encodeImpl(_this__u8e3s4, input, start, toIndex, dst);
  start = start + rc | 0;
  if (start === toIndex) {
    return readByteArray_0(dst);
  }
  encodeToImpl(_this__u8e3s4, dst, input, start, toIndex);
  return readByteArray_0(dst);
}
function CharsetEncoderImpl(charset) {
  CharsetEncoder.call(this, charset);
  this.k3o_1 = charset;
}
protoOf(CharsetEncoderImpl).toString = function () {
  return 'CharsetEncoderImpl(charset=' + this.k3o_1.toString() + ')';
};
protoOf(CharsetEncoderImpl).hashCode = function () {
  return this.k3o_1.hashCode();
};
protoOf(CharsetEncoderImpl).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CharsetEncoderImpl))
    return false;
  var tmp0_other_with_cast = other instanceof CharsetEncoderImpl ? other : THROW_CCE();
  if (!this.k3o_1.equals(tmp0_other_with_cast.k3o_1))
    return false;
  return true;
};
function CharsetDecoderImpl(charset) {
  CharsetDecoder.call(this, charset);
  this.m3o_1 = charset;
}
protoOf(CharsetDecoderImpl).toString = function () {
  return 'CharsetDecoderImpl(charset=' + this.m3o_1.toString() + ')';
};
protoOf(CharsetDecoderImpl).hashCode = function () {
  return this.m3o_1.hashCode();
};
protoOf(CharsetDecoderImpl).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CharsetDecoderImpl))
    return false;
  var tmp0_other_with_cast = other instanceof CharsetDecoderImpl ? other : THROW_CCE();
  if (!this.m3o_1.equals(tmp0_other_with_cast.m3o_1))
    return false;
  return true;
};
function encodeImpl(_this__u8e3s4, input, fromIndex, toIndex, dst) {
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(fromIndex <= toIndex)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException_init_$Create$(toString_1(message));
  }
  if (get_charset(_this__u8e3s4).equals(Charsets_getInstance().o3n_1)) {
    return encodeISO88591(input, fromIndex, toIndex, dst);
  }
  // Inline function 'kotlin.require' call
  if (!(get_charset(_this__u8e3s4) === Charsets_getInstance().n3n_1)) {
    var message_0 = 'Only UTF-8 encoding is supported in JS';
    throw IllegalArgumentException_init_$Create$(toString_1(message_0));
  }
  var encoder = new TextEncoder();
  // Inline function 'kotlin.text.substring' call
  var tmp$ret$5 = toString_1(charSequenceSubSequence(input, fromIndex, toIndex));
  var result = encoder.encode(tmp$ret$5);
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  dst.w39(result);
  return result.length;
}
function get_charset(_this__u8e3s4) {
  return _this__u8e3s4.h3o_1;
}
function decode_0(_this__u8e3s4, input, dst, max) {
  var decoder = Decoder(get_name(get_charset_0(_this__u8e3s4)), true);
  var tmp0 = input.j38().m();
  // Inline function 'kotlin.comparisons.minOf' call
  var b = toLong(max);
  var count = tmp0.b1(b) <= 0 ? tmp0 : b;
  var tmp = readByteArray(input, count.d1());
  var array = tmp instanceof Int8Array ? tmp : THROW_CCE();
  var tmp_0;
  try {
    tmp_0 = decoder.n3o(array);
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Error) {
      var cause = $p;
      var tmp0_elvis_lhs = cause.message;
      throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs == null ? 'no cause provided' : tmp0_elvis_lhs));
    } else {
      throw $p;
    }
  }
  var result = tmp_0;
  dst.f(result);
  return result.length;
}
function get_charset_0(_this__u8e3s4) {
  return _this__u8e3s4.g3o_1;
}
function forName(_this__u8e3s4, name) {
  return Companion_instance_3.e3o(name);
}
function isSupported(_this__u8e3s4, name) {
  return Companion_instance_3.f3o(name);
}
function Decoder(encoding, fatal) {
  fatal = fatal === VOID ? true : fatal;
  var tmp;
  try {
    tmp = toKtor(new TextDecoder(encoding, textDecoderOptions(fatal)));
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var cause = $p;
      tmp_0 = new TextDecoderFallback(encoding, fatal);
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function toKtor(_this__u8e3s4) {
  return new toKtor$1(_this__u8e3s4);
}
function textDecoderOptions(fatal) {
  fatal = fatal === VOID ? false : fatal;
  // Inline function 'kotlin.apply' call
  var this_0 = new Object();
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.with' call
  this_0.fatal = fatal;
  return this_0;
}
function toKtor$1($this_toKtor) {
  this.o3o_1 = $this_toKtor;
}
protoOf(toKtor$1).n3o = function (buffer) {
  return this.o3o_1.decode(buffer);
};
function get_ENCODING_ALIASES() {
  _init_properties_TextDecoderFallback_js_kt__an7r6m();
  return ENCODING_ALIASES;
}
var ENCODING_ALIASES;
function get_REPLACEMENT() {
  _init_properties_TextDecoderFallback_js_kt__an7r6m();
  return REPLACEMENT;
}
var REPLACEMENT;
function TextDecoderFallback(encoding, fatal) {
  this.p3o_1 = fatal;
  // Inline function 'kotlin.text.trim' call
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var requestedEncoding = toString_1(trim(isCharSequence(encoding) ? encoding : THROW_CCE())).toLowerCase();
  // Inline function 'kotlin.check' call
  if (!get_ENCODING_ALIASES().u1(requestedEncoding)) {
    var message = encoding + ' is not supported.';
    throw IllegalStateException_init_$Create$(toString_1(message));
  }
}
protoOf(TextDecoderFallback).n3o = function (buffer) {
  // Inline function 'io.ktor.utils.io.core.buildPacket' call
  var builder = new Buffer();
  var bytes = buffer instanceof Int8Array ? buffer : THROW_CCE();
  var inductionVariable = 0;
  var last = bytes.length;
  if (inductionVariable < last)
    $l$loop: do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'org.khronos.webgl.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var byte = bytes[index];
      var point = toCodePoint(byte);
      if (point < 0) {
        // Inline function 'kotlin.check' call
        if (!!this.p3o_1) {
          var message = 'Invalid character: ' + point;
          throw IllegalStateException_init_$Create$(toString_1(message));
        }
        writeFully_0(builder, get_REPLACEMENT());
        continue $l$loop;
      }
      if (point > 255) {
        builder.d3a(toByte(point >> 8));
      }
      builder.d3a(toByte(point & 255));
    }
     while (inductionVariable < last);
  return decodeToString(readByteArray_0(builder));
};
function toCodePoint(_this__u8e3s4) {
  _init_properties_TextDecoderFallback_js_kt__an7r6m();
  var value = _this__u8e3s4 & 255;
  if (isASCII(value)) {
    return value;
  }
  return get_WIN1252_TABLE()[value - 128 | 0];
}
function isASCII(_this__u8e3s4) {
  _init_properties_TextDecoderFallback_js_kt__an7r6m();
  return 0 <= _this__u8e3s4 ? _this__u8e3s4 <= 127 : false;
}
var properties_initialized_TextDecoderFallback_js_kt_6rekzk;
function _init_properties_TextDecoderFallback_js_kt__an7r6m() {
  if (!properties_initialized_TextDecoderFallback_js_kt_6rekzk) {
    properties_initialized_TextDecoderFallback_js_kt_6rekzk = true;
    ENCODING_ALIASES = setOf(['ansi_x3.4-1968', 'ascii', 'cp1252', 'cp819', 'csisolatin1', 'ibm819', 'iso-8859-1', 'iso-ir-100', 'iso8859-1', 'iso88591', 'iso_8859-1', 'iso_8859-1:1987', 'l1', 'latin1', 'us-ascii', 'windows-1252', 'x-cp1252']);
    // Inline function 'kotlin.byteArrayOf' call
    REPLACEMENT = new Int8Array([-17, -65, -67]);
  }
}
function get_DEVELOPMENT_MODE() {
  return false;
}
function encodeISO88591(input, fromIndex, toIndex, dst) {
  if (fromIndex >= toIndex)
    return 0;
  var inductionVariable = fromIndex;
  if (inductionVariable < toIndex)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.code' call
      var this_0 = charSequenceGet(input, index);
      var character = Char__toInt_impl_vasixd(this_0);
      if (character > 255) {
        failedToMapError(character);
      }
      dst.d3a(toByte(character));
    }
     while (inductionVariable < toIndex);
  return toIndex - fromIndex | 0;
}
function failedToMapError(ch) {
  throw new MalformedInputException('The character with unicode point ' + ch + " couldn't be mapped to ISO-8859-1 character");
}
function get_WIN1252_TABLE() {
  _init_properties_Win1252Table_kt__tl0v64();
  return WIN1252_TABLE;
}
var WIN1252_TABLE;
var properties_initialized_Win1252Table_kt_pkmjoq;
function _init_properties_Win1252Table_kt__tl0v64() {
  if (!properties_initialized_Win1252Table_kt_pkmjoq) {
    properties_initialized_Win1252Table_kt_pkmjoq = true;
    // Inline function 'kotlin.intArrayOf' call
    WIN1252_TABLE = new Int32Array([8364, -1, 8218, 402, 8222, 8230, 8224, 8225, 710, 8240, 352, 8249, 338, -1, 381, -1, -1, 8216, 8217, 8220, 8221, 8226, 8211, 8212, 732, 8482, 353, 8250, 339, -1, 382, 376, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255]);
  }
}
function DefaultPool(capacity) {
  this.w3n_1 = capacity;
  var tmp = this;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = this.w3n_1;
  tmp.x3n_1 = Array(size);
  this.y3n_1 = 0;
}
protoOf(DefaultPool).z3n = function (instance) {
};
protoOf(DefaultPool).a3o = function (instance) {
  return instance;
};
protoOf(DefaultPool).b3o = function (instance) {
};
protoOf(DefaultPool).c3o = function () {
  if (this.y3n_1 === 0)
    return this.v3n();
  this.y3n_1 = this.y3n_1 - 1 | 0;
  var idx = this.y3n_1;
  var tmp = this.x3n_1[idx];
  var instance = !(tmp == null) ? tmp : THROW_CCE();
  this.x3n_1[idx] = null;
  return this.a3o(instance);
};
protoOf(DefaultPool).d3o = function (instance) {
  this.b3o(instance);
  if (this.y3n_1 === this.w3n_1) {
    this.z3n(instance);
  } else {
    var _unary__edvuaz = this.y3n_1;
    this.y3n_1 = _unary__edvuaz + 1 | 0;
    this.x3n_1[_unary__edvuaz] = instance;
  }
};
protoOf(DefaultPool).x1h = function () {
  var inductionVariable = 0;
  var last = this.y3n_1;
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = this.x3n_1[i];
      var instance = !(tmp == null) ? tmp : THROW_CCE();
      this.x3n_1[i] = null;
      this.z3n(instance);
    }
     while (inductionVariable < last);
  this.y3n_1 = 0;
};
//region block: post-declaration
protoOf(Read).o3b = resume;
protoOf(Read).p3b = resume_0;
protoOf(Write).o3b = resume;
protoOf(Write).p3b = resume_0;
protoOf(ByteChannel).z3d = awaitContent$default;
protoOf(ByteReadChannel$Companion$Empty$1).z3d = awaitContent$default;
protoOf(CountedByteReadChannel).z3d = awaitContent$default;
protoOf(SourceByteReadChannel).z3d = awaitContent$default;
protoOf(DefaultPool).a4 = close;
protoOf(NoPoolImpl).a4 = close;
//endregion
//region block: init
Empty_instance = new Empty();
Companion_instance_3 = new Companion_2();
//endregion
//region block: exports
export {
  copyTo as copyTo2bqjr21is71ky,
  readAvailable as readAvailablep1f2sbmaa5jo,
  readPacket as readPacket12c3kakna35tv,
  readRemaining as readRemaining33cdmbznvdvtg,
  readUTF8LineTo as readUTF8LineTo2rqyj2iri7j7e,
  readUntil as readUntilqaod88ylrtua,
  skipIfFound as skipIfFound2s927ggnjlzu8,
  toByteArray as toByteArray3qclveibivokh,
  writeFully as writeFully2bplh4smpa61x,
  writePacket as writePacket3r7d9cbv7uxna,
  LineEndingMode__plus_impl_ttpz2j as LineEndingMode__plus_impl_ttpz2j1fo728zjvbdzc,
  Charsets_getInstance as Charsets_getInstancemd62gu5po4os,
  Companion_getInstance_0 as Companion_getInstancekyay2rfrglll,
  Companion_getInstance_1 as Companion_getInstance2golwmcx6d471,
  MalformedInputException as MalformedInputExceptionbvc6h5ij0ias,
  decode as decode1t43jmuxrxpmo,
  encode as encode35e4rpnc94tb5,
  forName as forName2faodmskqnoz5,
  isSupported as isSupported2nf870ypy50et,
  get_name as get_name2f11g4r0d5pxp,
  BytePacketBuilder as BytePacketBuilder2biodf4wxvlba,
  build as buildjygoh729rhy8,
  canRead as canRead1guo8vbveth0f,
  discard_0 as discard3ugntd47xyll6,
  readText_0 as readText27783kyxjxi1g,
  get_remaining as get_remaining1lapv95kcmm0y,
  get_size as get_size2imoy2jq11jxl,
  takeWhile as takeWhile34751tcfg6owx,
  toByteArray_0 as toByteArray1i3ns5jnoqlv6,
  writeFully_0 as writeFully359t6q8kam2g5,
  writePacket_0 as writePacket1weetk0dtcyx2,
  writeText as writeText19qfzm98fbm4l,
  get_ByteArrayPool as get_ByteArrayPool3f7yrgvqxz9ct,
  DefaultPool as DefaultPool2gb1fm4epwgu9,
  NoPoolImpl as NoPoolImplgos9n8jphzjp,
  ByteChannel as ByteChannel3cxdguezl3lu7,
  ByteReadChannel as ByteReadChannel1cb89sbyipkce,
  ByteReadChannel_1 as ByteReadChannel2wzou76jce72d,
  ClosedByteChannelException as ClosedByteChannelException3il8gfpye60w,
  WriterScope as WriterScope3b0bo1enaee6b,
  get_availableForRead as get_availableForRead28yb35u7qm4tu,
  cancel_0 as canceldn4b3cdqcfny,
  close_0 as close3semq7pafb42g,
  counted as counted3iniv3aql3f9n,
  invokeOnCompletion as invokeOnCompletionvmw9mjsupd6z,
  get_isCompleted as get_isCompleted2vv2dxgxvs29m,
  readText as readText3frapgncbqrcg,
  writer as writer1eia5its2a1fh,
};
//endregion

